/* global YT */

import Slide from './slide'

let youtubeApiLoaded = false
let youtubeApiLoadInitiated = false
const youtubeApiLoadCallbacks = []

// We need to remember playback state for each video since sometimes slides
// could be copied
const playbackStates = {}

function loadYoutubeApi () {
  youtubeApiLoadInitiated = true
  const tag = document.createElement('script')
  tag.src = 'https://www.youtube.com/iframe_api'
  document.head.appendChild(tag)
}

function afterYoutubeApiLoad (callback) {
  if (!youtubeApiLoadInitiated) loadYoutubeApi()

  if (youtubeApiLoaded) {
    callback()
  } else {
    youtubeApiLoadCallbacks.push(callback)
  }
}

window.onYouTubeIframeAPIReady = () => {
  youtubeApiLoaded = true

  youtubeApiLoadCallbacks.forEach((callback) => callback())
}

export default class VideoSlide extends Slide {
  constructor (data, number, options, errorCallback) {
    super(data, number, { ...options, linkTo: undefined, cropImages: true }, errorCallback)
  }

  copy () {
    return new VideoSlide({
      img: this.srcset,
      video: this.video,
      title: this.title,
      subtitle: this.subtitle
    }, this.index, this.options, this.onErrorCallback)
  }

  blur () {
    if (this.player) this.pause()
  }

  stop () {
    if (this.player) this.player.stopVideo()
  }

  build (slidesContainer) {
    super.build(slidesContainer)

    this.videoContainer = document.createElement('div')
    this.videoContainer.className = 'media-slider__video'
    this.videoContainer.id = `slide_${this.id}`
    this.container.dataset.number = this.number.toString()

    this.container.appendChild(this.videoContainer)
    this.playButton.addEventListener('click', () => this.play(), false)

    afterYoutubeApiLoad(() => {
      this.player = new YT.Player(this.videoContainer.id, {
        videoId: this.video,
        events: {
          onReady: () => {
            this.playerInitiated = true
            if (this.playScheduled) this.play()
          }
        }
      })
    })
  }

  play () {
    if (this.playerInitiated) {
      this.player.seekTo(playbackStates[this.video] || 0)
      this.player.playVideo()
      this.container.classList.add('media-slider__slide--video-active')
    } else {
      this.playScheduled = true
    }
  }

  pause () {
    if (this.playerInitiated) {
      playbackStates[this.video] = this.player.getCurrentTime()

      this.player.pauseVideo()
      this.container.classList.remove('media-slider__slide--video-active')
    }
  }
}
